import React, { useState, useContext, useEffect } from 'react';
import { Grid, Box, Button, TextField, Container } from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material/';
import '../../assets/css/buttons.css';

import ClubHouseLogo from '../../assets/img/clubhouse_logo.png';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../context/Context';
import LoginIcon from '@mui/icons-material/Person';
import { useTranslation } from 'react-i18next';

import { SocketContext } from '../../context/SocketContext';
import { SocketNFCContext } from '../../context/SocketNFC';

import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import html2canvas from 'html2canvas';

function Login() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    updateIsFirstShiftOfTheDay,
    updateShowModalStartShift,
    updateMaximumAnonPrizeAllowed,
    updateKiosk,
    updateIsPapirEnabled,
    updateIsPapirKingoEnabled,
    updateIsPapirXtippEnabled,
    updateIsSystemLockEnabled,
    updateIsDataBingoBlocked,
    updateIsMainGameBlocked,
    isLogin,
    updateLogin,
    modifyOperator,
    isBlocking,
    BlockingScreen,
    updateSession,
    modifyOperatorFull,
    modifyOperatorInfo,
    modifyHall,
    updatePrinter,
    updatePrinterIP,
    updateCardID,
    updateOKBingoID,
    updateIsOKBingoEnabled,
    enviroment,
    isNTEnabled,
    updateIsNTEnabled,
    isKioskEnabled,
    updateIsKioskEnabled,
    updateBingoID,
    updateIsEnabledBankID,
    updateIsWGEnabled,
    updateWGBingoID,
    updateIsAdmin,
    updateCloseTime,
    updateIsLoadingScreen,
  } = useContext(AppContext);

  var isLoading = false;
  const { socket } = useContext(SocketContext);
  const socketNFC = useContext(SocketNFCContext);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  // Stage switcher — only shown on the stage01/stage02 environments.
  const hostname =
    typeof window !== 'undefined' ? window.location.hostname : '';
  const currentStage = hostname.includes('stage01')
    ? 'stage01'
    : hostname.includes('stage02')
      ? 'stage02'
      : null;
  const targetStage =
    currentStage === 'stage01'
      ? 'stage02'
      : currentStage === 'stage02'
        ? 'stage01'
        : null;

  const [showStageModal, setShowStageModal] = useState(false);
  const [isSwitchingStage, setIsSwitchingStage] = useState(false);

  const switchStageTask = async () => {
    if (!targetStage || isSwitchingStage) {
      return;
    }

    setIsSwitchingStage(true);
    try {
      const url = `https://${currentStage}-operator.vpfscandinavia.com/api/switch-stage`;
      console.log('Switch stage URL: ' + url);
      await axios.post(url, { stage: targetStage });
      toast.success(t('login.switchStageSuccess', { target: targetStage }));
      setShowStageModal(false);
      updateIsLoadingScreen(true);
    } catch (err) {
      console.error(err);
      toast.error(t('login.switchStageError'));
    } finally {
      setIsSwitchingStage(false);
    }
  };

  const loginTask = async () => {
    if (isLoading) {
      return;
    }

    if (!username || !password) {
      toast.error(t('error.empty'));
      return;
    }

    isLoading = true;

    let dataRequest = {
      username: username,
      password: password,
    };

    try {
      const hostname = window.location.hostname;
      var url = 'https://stage01-operator.vpfscandinavia.com';

      if (hostname === 'localhost') {
        url = 'https://stage01-operator.clubhouse.no/api/login';
      } else if (hostname.includes('stage01')) {
        url = 'https://stage01-operator.clubhouse.no/api/login/';
      } else if (hostname.includes('stage02')) {
        url = 'https://stage02-operator.clubhouse.no/api/login/';
      } else {
        url = 'https://operator.clubhouse.no/api/login/';
      }

      console.log('Login URL: ' + url);
      console.log(dataRequest);

      var response = await axios({
        method: 'post',
        url: url,
        data: dataRequest,
      });

      console.log(response);

      //const cookieString = response.headers["set-cookie"][0];
      //const sessValue = cookieString.split(";")[0].split("=")[1];

      const sessValue = response.data.operator.auth;
      response.data.session = sessValue;

      //Temp get countries
      //socket.emit("getCountries", response.data);

      if (!response) {
        isLoading = false;
        toast.error(t('error.login'));
        return;
      }

      updateSession(sessValue);
      modifyOperator(response.data.operator.username);
      modifyOperatorFull(response.data.operator.firstName);
      modifyHall(response.data.hall.name);
      modifyOperatorInfo(response.data);
      updateBingoID(response.data.hall.id);

      isLoading = false;

      var dataSocket = {
        operator: username,
        password: password,
        sessionID: sessValue,
        operatorInfo: response.data,
        platform: 'cashier',
      };
      socket.emit('registerLogin', dataSocket);

      //navigate("/salgs");
    } catch (err) {
      console.error(err);
      isLoading = false;
      toast.error(t('error.login'));
      return;
    }

    /*
    var data = {
      username: username,
      password: password,
      action: "login",
    };
    socket.emit("login", data);
    */
  };

  useEffect(() => {
    const handleLogin = (data) => {
      if (!data) {
        isLoading = false;
        toast.error(t('error.login'));
        return;
      }

      if (!data) {
        isLoading = false;
        toast.error(t('error.login'));
        return;
      }
      modifyOperator(data.operator.username);
      modifyOperatorFull(data.operator.firstName);
      modifyHall(data.hall.name);
      updateLogin(true);
      updateSession(data.session);
      isLoading = false;

      socket.emit('registerLogin', data);
      //navigate("/salgs");
    };

    const handleGetCountries = (data) => {
      //console.log("countries");
      //console.log(data);
    };

    const handleRegisterLogin = (data) => {
      console.log('handleRegisterLogin', data);

      if (data.printerIp) {
        updatePrinterIP(data.printerIp);
        updatePrinter({
          text: '',
          name: '',
          id: '',
          ip: data.printerIp,
        });
      }

      if (data.schedule) {
        updateCloseTime(data.schedule.closeTime);
      }

      if (data.isEnabledBankID) {
        updateIsEnabledBankID(true);
      }

      if (data.isAdmin) {
        updateIsAdmin(true);
      } else {
        updateIsAdmin(false);
      }

      updateCardID(data.terminalID ?? '');

      for (var i = 0; i < data.bingoList.length; i++) {
        if (
          data.bingoList[i].bingoName === data.operatorInfo.hall.name &&
          data.bingoList[i].isEnabled
        ) {
          updateOKBingoID(data.bingoList[i].bingoID);
          updateIsOKBingoEnabled(true);
          break;
        }
      }

      for (var i = 0; i < data.isWGEnabled.length; i++) {
        if (
          data.isWGEnabled[i].bingoName === data.operatorInfo.hall.name &&
          data.isWGEnabled[i].isEnabled
        ) {
          updateWGBingoID(data.isWGEnabled[i].bingoID);
          updateIsWGEnabled(true);
          break;
        }
      }

      for (var i = 0; i < data.isNTEnabled.length; i++) {
        if (
          data.isNTEnabled[i].bingoName === data.operatorInfo.hall.name &&
          data.isNTEnabled[i].isEnabled
        ) {
          updateIsNTEnabled(true);
          break;
        }
      }

      for (var i = 0; i < data.isPapirEnabled.length; i++) {
        if (
          data.isPapirEnabled[i].bingoName === data.operatorInfo.hall.name &&
          data.isPapirEnabled[i].isEnabled
        ) {
          updateIsPapirEnabled(true);
          break;
        }
      }

      for (var i = 0; i < data.isPapirKingoEnabled.length; i++) {
        if (
          data.isPapirKingoEnabled[i].bingoName ===
            data.operatorInfo.hall.name &&
          data.isPapirKingoEnabled[i].isEnabled
        ) {
          updateIsPapirKingoEnabled(true);
          break;
        }
      }

      for (var i = 0; i < data.isPapirXtippEnabled.length; i++) {
        if (
          data.isPapirXtippEnabled[i].bingoName ===
            data.operatorInfo.hall.name &&
          data.isPapirXtippEnabled[i].isEnabled
        ) {
          updateIsPapirXtippEnabled(true);
          break;
        }
      }

      for (var i = 0; i < data.isKioskEnabled.length; i++) {
        if (
          data.isKioskEnabled[i].bingoName === data.operatorInfo.hall.name &&
          data.isKioskEnabled[i].isEnabled
        ) {
          updateIsKioskEnabled(true);
          break;
        }
      }

      updateKiosk(data.kiosk);
      updateMaximumAnonPrizeAllowed(data.maximumAnonPrizeAllowed);

      /*
      if (data.isMainGameBlockEnabled === 1) {
        updateIsMainGameBlocked(true);
      }

      if (data.isDataBingoBlockEnabled === 1) {
        updateIsDataBingoBlocked(true);
      }
      */

      if (data.isSystemLockEnabled === 1) {
        updateIsSystemLockEnabled(true);
      }

      if (!data.isOpenShift) {
        updateShowModalStartShift(true);
      }

      if (data.isFirstOfTheDay) {
        updateIsFirstShiftOfTheDay(true);
      }

      updateLogin(true);
      navigate('/salgs');
    };

    socket.on('registerLogin', handleRegisterLogin);
    socket.on('login', handleLogin);
    socket.on('getCountries', handleGetCountries);

    return () => {
      socket.off('registerLogin', handleRegisterLogin);
      socket.off('login', handleLogin);
      socket.off('getCountries', handleGetCountries);
    };
  }, [socket]);

  useEffect(() => {
    return () => {};
  }, [socketNFC]);

  useEffect(() => {
    if (isLogin) {
      navigate('/salgs');
      return;
    }

    const handleKeyPress = (event) => {
      if (event.key === 'Enter') {
        handleFormSubmit();
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  const handleFormSubmit = (event) => {
    if (event) {
      event.preventDefault();
    }
  };

  return (
    <>
      {isBlocking && <BlockingScreen />}

      {currentStage && (
        <Box
          sx={{
            position: 'fixed',
            top: 12,
            right: 16,
            zIndex: 1300,
          }}
        >
          <Button
            size="small"
            variant="text"
            onClick={() => setShowStageModal(true)}
            sx={{
              textTransform: 'none',
              color: '#8fa3d4',
              fontSize: '13px',
              fontWeight: 600,
            }}
          >
            {t('login.switchStageLabel', {
              current: currentStage,
              target: targetStage,
            })}
          </Button>
        </Box>
      )}

      {showStageModal && (
        <div id="react-confirm-alert">
          <div className="react-confirm-alert-overlay">
            <div className="react-confirm-alert">
              <div
                className="react-confirm-alert-body"
                style={{ width: '760px' }}
              >
                <h1>{t('login.switchStageTitle', { target: targetStage })}</h1>
                <p>{t('login.switchStageMessage')}</p>

                <div className="react-confirm-alert-button-group">
                  <button
                    className="btn-custom-yes"
                    onClick={() => {
                      switchStageTask();
                    }}
                    disabled={isSwitchingStage}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                    }}
                  >
                    <CheckCircleIcon style={{ fontSize: '1.2em' }} />
                    {isSwitchingStage
                      ? t('login.switchStageSwitching')
                      : t('sales.confirm')}
                  </button>

                  <button
                    className="btn-custom-no"
                    onClick={() => {
                      setShowStageModal(false);
                    }}
                    disabled={isSwitchingStage}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                    }}
                  >
                    <CancelIcon style={{ fontSize: '1.2em' }} />
                    {t('sales.cancel')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          width: '100vw',
        }}
      >
        <Toaster position="top-center" reverseOrder={false} />

        <Box
          component="img"
          sx={{
            height: '300px',
            width: 'auto',
            paddingTop: 0,
          }}
          alt=""
          src={ClubHouseLogo}
        />

        <form
          noValidate
          autoComplete="off"
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: '400px',
            width: '400px',
            minWidth: '400px',
            justifyContent: 'center',
          }}
          onSubmit={handleFormSubmit}
        >
          <Grid container direction={'column'} spacing={5}>
            <Grid item style={{ width: '100%' }}>
              <TextField
                autoFocus
                sx={{
                  width: '100%',
                }}
                label={t('login.username')}
                variant="outlined"
                onChange={(event) => {
                  setUsername(event.target.value);
                }}
              />
            </Grid>
            <Grid item>
              <TextField
                sx={{
                  width: '100%',
                }}
                label={t('login.password')}
                type="password"
                autoComplete="current-password"
                variant="outlined"
                onChange={(event) => {
                  setPassword(event.target.value);
                }}
              />
            </Grid>
            <Grid item>
              <Button
                type="submit"
                variant="contained"
                color={isLoading ? 'disabled' : 'primary'}
                sx={{
                  height: '60px !important',
                  width: '100%',
                  backgroundColor: '#2f49cf',
                  color: 'white',
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                }}
                startIcon={<LoginIcon />}
                onClick={() => {
                  loginTask();
                }}
              >
                {t('login.login')}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Container>
    </>
  );
}

export default Login;
